import { Component, OnInit, Input } from '@angular/core';
import { AppyUser } from '../../../core/model/v2/AppyUser'
import { UserService } from '../../../core/services/v2/user.service';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { CommonService } from '../../../core/services/v2/common.service';
import { SupportRequestComponent } from '../../../shared/components/SupportRequest/SupportRequest.component';
import { SideBarInitializeParameters } from '../../../shared/components/dynamic-right-sidebar/SideBarInitializeParameters';
import { MatDialog } from '@angular/material';
import { SendMultipleMessagesComponent } from '../../../physician/chat/send-multiple-messages/send-multiple-messages.component';
import { debug } from 'util';


@Component({
  selector: 'app-layoutsidebar',
  templateUrl: './layoutsidebar.component.html',
  styleUrls: ['./layoutsidebar.component.scss']
})
export class LayoutsidebarComponent implements OnInit {
  @Input() isAdmin: boolean;
  @Input() isExpandNav: boolean;
  @Input() isAHIAdmin: boolean;

  isActive: boolean;

  role: string;
  showSidebar: boolean = true;
  profilelist = true;
  hasAccess: boolean = false;
  sidebar = {
    referralsCollapsed: false,
    settingsCollapsed: false,
  };

  constructor(private userService: UserService, private commonService: CommonService, private practiceService: PracticeService, public dialog: MatDialog) { }

  ngOnInit() {
    this.userService.getUserDetails().subscribe(
      (result) => {
        this.role = result.role.toLowerCase();
        this.hasAccess = this.hasAccess || result.role.toLowerCase() === 'callcenter';
      },
      (error) => { console.error(error); });

    this.userService.getMyHealthSystems().subscribe(
      (result) => { this.hasAccess = this.hasAccess || (result && !!result.length); },
      (error) => { console.error(error); }
    );
  }

  canManageProfessionals()
  {
    return this.isAdmin || this.practiceService.currentUserIsStaff();
  }

  openSupportRequest() {
    const supportRequest = <SideBarInitializeParameters> {
      componentType: SupportRequestComponent
    };
    
    this.commonService.rightSideBarComponent$.next(supportRequest);
  }
  openMessage() {
    
    
    this.dialog.open(SendMultipleMessagesComponent, {
      width: "42%",
      height: "93%",
      data: { isFromAdmin: true },
    });
  }

}
